import { useTranslation } from 'react-i18next';
import { useRequest } from '@success/forms';
import { getSessionData } from '@/services';

import '../../translation/i18n';

export function useTranslate() {
  const { i18n } = useTranslation();

  const userInfo = useRequest({
    manual: false,
    async request() {
      const session = getSessionData();
      const currentLng = session?.lng || 'pt';

      await i18n.changeLanguage(currentLng);
      return { lang_user: currentLng };
    },
  });

  return userInfo;
}
